(function () {
  'use strict';

  a3_cabin_reports.directive('departureInfoPanel', departureInfoPanel);

  /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name departureInfoPanel
   * @restrict EA
   * @description
   *   Departure Info Panel using separate controller.
   * @example
   *   <departure-info-panel></departure-info-panel>
   * @ngInject
   */
  function departureInfoPanel() {
    return {
      restrict: 'EA',
      templateUrl: 'views/directives/departureInfoPanel.tpl.html',
      scope: {},
      controller: 'JeppessenFlightDetailsCtrl'
    };
  }
})();
